<template>
    <div>
        <!-- Navbar -->
        <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
            <!-- <the-navbar-horizontal :navbarType="navbarType" :class="[{ 'text-white': isNavbarDark && !isThemeDark }, { 'text-base': !isNavbarDark && isThemeDark }]" /> -->
            <template v-if="currentUser.id != null">
                <h-nav-menu
                    :class="[
                        { 'text-white': isNavbarDark && !isThemeDark },
                        { 'text-base': !isNavbarDark && isThemeDark }
                    ]"
                />
            </template>
        </template>

        <template v-else>
            <template v-if="currentUser.id != null">
                <the-navbar-vertical
                    :navbarColor="navbarColor"
                    :class="[
                        { 'text-white': isNavbarDark && !isThemeDark },
                        { 'text-base': !isNavbarDark && isThemeDark }
                    ]"
                />

                <v-nav-menu
                    :class="[
                        { 'text-white': isNavbarDark && !isThemeDark },
                        { 'text-base': !isNavbarDark && isThemeDark }
                    ]"
                />
            </template>
        </template>
        <!-- /Navbar -->
        <wellful-logo />
    </div>
</template>

<script>
import HNavMenu from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
// import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical from '@/layouts/components/navbar/TheNavbarVertical.vue'
import VNavMenu from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import themeConfig from '@/../themeConfig.js'
import WellfulLogo from '../logo/WellfulLogo.vue'
import { mapParams } from '@/plugins/mappers'
import { mapGetters } from 'vuex'

export default {
    name: 'navbar',
    data() {
        return {
            activeItem: 0,
            isNavbarDark: false,
            navbarColor: themeConfig.navbarColor || '#fff',
            navbarType: themeConfig.navbarType || 'floating',
            routerTransition: themeConfig.routerTransition || 'none',
            routeTitle: this.$route.meta.pageTitle
        }
    },
    components: {
        WellfulLogo,
        HNavMenu,
        // TheNavbarHorizontal,
        TheNavbarVertical,
        VNavMenu
    },
    computed: {
        ...mapGetters({
            currentUser: 'auth/current_user'
        }),
        isThemeDark() {
            return this.$store.state.theme == 'dark'
        },
        mainLayoutType() {
            // return this.$store.state.mainLayoutType
            return 'horizontal'
        },
        windowWidth() {
            return this.$store.state.windowWidth
        },
        ...mapParams({
            couponCode: 'couponCode'
        })
    }
}
</script>

<style scoped>
.margin-left {
    margin-left: -80%;
}

::v-deep .vx-navbar-wrapper {
    height: 62px;
}
</style>
